import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';
import { getCommunitiesForYou, getHomesForYou } from 'constants/routes'

/**
 * getCommunitiesForYouContent: observable to fetch the communities for you content from blog controller.
 * response.text() to map the partial result
 */
export const getCommunitiesForYouContent$ = (CommunitiesSearchParameters) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      BlogListingsFiltersSearchCommand: {
        ...CommunitiesSearchParameters,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(getCommunitiesForYou, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(''))
  );
}

/**
 * getListingForYouContent: observable to fetch the homes for you content from blog controller.
 * response.text() to map the partial result
 */
export const getHomesForYouContent$ = (homeSearchParameters) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      BlogListingsFiltersSearchCommand: {
        ...homeSearchParameters,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(getHomesForYou, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(''))
  );
}
